import * as actions from '../../actions'
import * as storage from '../../../utils/storage'

const defaultState = null

export default function moduleSelected(state = defaultState, action) {
    switch (action.type) {
        case actions.SELECT_MODULE:
            if (action.payload && action.payload !== state) {
                state = action.payload
                storage.set('moduleSelected', state)
            }
            return state

        case actions.CLEAN_ALL:
        case actions.APP_SELECT:
            storage.remove('moduleSelected')
            return defaultState

        default:
            return state
    }
}
